import { useEffect, useState } from "react";
import { getGlobalSettings, saveGlobalSettings } from "./adminCalendarService";
import "./calendar.css";

const DAYS = ["MON", "TUE", "WED", "THU", "FRI", "SAT", "SUN"];

const AdminGlobalCalendarSettingsPage = () => {
  const [studyDays, setStudyDays] = useState([]);
  const [cutoff, setCutoff] = useState(24);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [msg, setMsg] = useState("");

  useEffect(() => {
    getGlobalSettings()
      .then((res) => {
        setStudyDays(res.data.studyDays ? res.data.studyDays.split(",") : []);
        setCutoff(res.data.unavailabilityCutoffHours ?? 24);
      })
      .finally(() => setLoading(false));
  }, []);

  const toggleDay = (day) =>
    setStudyDays((prev) =>
      prev.includes(day) ? prev.filter((d) => d !== day) : [...prev, day]
    );

  const handleSave = async () => {
    setSaving(true);
    setMsg("");
    try {
      await saveGlobalSettings({
        studyDays: DAYS.filter((d) => studyDays.includes(d)).join(","),
        unavailabilityCutoffHours: Number(cutoff),
      });
      setMsg("Settings saved.");
    } catch {
      setMsg("Failed to save.");
    } finally {
      setSaving(false);
    }
  };

  if (loading) return <div className="ac-loading">Loading…</div>;

  return (
    <div>
      <div className="ac-header">
        <h2>Global Calendar Settings</h2>
      </div>

      <div className="ac-form-card">
        <div className="ac-form-group">
          <label>Study Days</label>
          <div className="cal-days-group">
            {DAYS.map((d) => (
              <label key={d} className={`cal-day-check ${studyDays.includes(d) ? "checked" : ""}`}>
                <input type="checkbox" checked={studyDays.includes(d)} onChange={() => toggleDay(d)} />
                {d}
              </label>
            ))}
          </div>
        </div>

        <div className="ac-form-group" style={{ maxWidth: 200 }}>
          <label>Unavailability Cutoff (hours)</label>
          <input
            type="number"
            min={0}
            value={cutoff}
            onChange={(e) => setCutoff(e.target.value)}
          />
        </div>

        <div className="ac-actions">
          <button className="ac-btn ac-btn-primary" onClick={handleSave} disabled={saving}>
            {saving ? "Saving…" : "Save Settings"}
          </button>
        </div>

        {msg && (
          <div style={{ marginTop: "0.75rem", fontSize: "0.85rem", color: msg.includes("Failed") ? "#dc2626" : "#16a34a" }}>
            {msg}
          </div>
        )}
      </div>
    </div>
  );
};

export default AdminGlobalCalendarSettingsPage;
